!function (a, b) {
  "function" == typeof define && define.amd ? define([], function () {
    return a.returnExportsGlobal = b();
  }) : "object" == typeof exports ? module.exports = b() : a.ResizeSensor = b();
}(this, function () {
  var a = function () {
    "use strict";

    function a() {
      this.q = [], this.add = function (a) {
        this.q.push(a);
      };
      var a, b;

      this.call = function () {
        for (a = 0, b = this.q.length; b > a; a++) {
          this.q[a].call();
        }
      };
    }

    function b(a, b) {
      return a.currentStyle ? a.currentStyle[b] : window.getComputedStyle ? window.getComputedStyle(a, null).getPropertyValue(b) : a.style[b];
    }

    function c(c, e) {
      if (c.resizedAttached) {
        if (c.resizedAttached) return void c.resizedAttached.add(e);
      } else c.resizedAttached = new a(), c.resizedAttached.add(e);

      c.resizeSensor = document.createElement("div"), c.resizeSensor.className = "resize-sensor";
      var f = "position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden; opacity: 0;",
          g = "position: absolute; left: 0; top: 0; transition: 0s;";
      c.resizeSensor.style.cssText = f, c.resizeSensor.innerHTML = '<div class="resize-sensor-expand" style="' + f + '"><div style="' + g + '"></div></div><div class="resize-sensor-shrink" style="' + f + '"><div style="' + g + ' width: 200%; height: 200%"></div></div>', c.appendChild(c.resizeSensor), "static" == b(c, "position") && (c.style.position = "relative");

      var h = c.resizeSensor.childNodes[0],
          i = h.childNodes[0],
          j = c.resizeSensor.childNodes[1],
          k = function k() {
        i.style.width = 1e5 + "px", i.style.height = 1e5 + "px", h.scrollLeft = 1e5, h.scrollTop = 1e5, j.scrollLeft = 1e5, j.scrollTop = 1e5;
      };

      k();

      var l = !1,
          m = function m() {
        c.resizedAttached && (l && (c.resizedAttached.call(), l = !1), d(m));
      };

      d(m);

      var n,
          o,
          p,
          q,
          r = function r() {
        ((p = c.offsetWidth) != n || (q = c.offsetHeight) != o) && (l = !0, n = p, o = q), k();
      },
          s = function s(a, b, c) {
        a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener(b, c);
      };

      s(h, "scroll", r), s(j, "scroll", r);
    }

    var d = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (a) {
      return window.setTimeout(a, 20);
    },
        e = function e(a, b) {
      var d = this,
          e = Object.prototype.toString.call(a),
          f = d._isCollectionTyped = "[object Array]" === e || "[object NodeList]" === e || "[object HTMLCollection]" === e || "undefined" != typeof jQuery && a instanceof window.jQuery || "undefined" != typeof Elements && a instanceof window.Elements;
      if (d._element = a, f) for (var g = 0, h = a.length; h > g; g++) {
        c(a[g], b);
      } else c(a, b);
    };

    return e.prototype.detach = function () {
      var a = this,
          b = a._isCollectionTyped,
          c = a._element;
      if (b) for (var d = 0, f = c.length; f > d; d++) {
        e.detach(c[d]);
      } else e.detach(c);
    }, e.detach = function (a) {
      a.resizeSensor && (a.removeChild(a.resizeSensor), delete a.resizeSensor, delete a.resizedAttached);
    }, e;
  }();

  return a;
});